export default "__VITE_ASSET__CpzQkV4I__"